export default "__VITE_ASSET__k8rCwN9n__"